// src/services/lottieService.js

// 👉 Importa todos tus archivos Lottie
import alert from "../assets/lotties/friendly/alert.json";
import alumn1 from "../assets/lotties/friendly/alumn1.json";
import bellAlert from "../assets/lotties/friendly/bell_alert.json";
import bonus from "../assets/lotties/friendly/bonus.json";
import book from "../assets/lotties/friendly/book.json";
import bookFinal from "../assets/lotties/friendly/bookFinal.json";
import books from "../assets/lotties/friendly/books.json";
import books3 from "../assets/lotties/friendly/books3.json";
import bookStar from "../assets/lotties/friendly/bookStar.json";
import bookPen from "../assets/lotties/friendly/book_pen.json";
import champ from "../assets/lotties/friendly/champ.json";
import chooseOption from "../assets/lotties/friendly/choose-option.json";
import claseDistancia from "../assets/lotties/friendly/clase_a_distancia.json";
import cuestionarios from "../assets/lotties/friendly/cuestionarios.json";
import cup from "../assets/lotties/friendly/cup.json";
import cup2 from "../assets/lotties/friendly/cup2.json";
import gift from "../assets/lotties/friendly/gift.json";
import gift2 from "../assets/lotties/friendly/gift2.json";
import gift3 from "../assets/lotties/friendly/gift3.json";
import goldChamp from "../assets/lotties/friendly/goldChamp.json";
import good from "../assets/lotties/friendly/good.json";
import goodCheck from "../assets/lotties/friendly/goodCheck.json";
import goodCheckAplic from "../assets/lotties/friendly/goodCheckAplic.json";
import goodCheckBio from "../assets/lotties/friendly/goodcheckBio.json";
import goodCheckEsp from "../assets/lotties/friendly/goodCheckEsp.json";
import goodCheckFilo from "../assets/lotties/friendly/goodCheckFilo.json";
import goodCheckFisAdmon from "../assets/lotties/friendly/goodCheckFisAdmon.json";
import goodCheckGeo from "../assets/lotties/friendly/goodCheckGeo.json";
import goodCheckIng from "../assets/lotties/friendly/goodCheckIng.json";
import goodCheckMatSoc from "../assets/lotties/friendly/goodCheckMatSoc.json";
import goodCheckQuimHist from "../assets/lotties/friendly/goodCheckQuimHist.json";
import horario from "../assets/lotties/friendly/horario.json";
import instrucBio from "../assets/lotties/friendly/instrucBio.json";
import instrucFil from "../assets/lotties/friendly/instrucFil.json";
import instrucFis from "../assets/lotties/friendly/instrucFis.json";
import instrucFis2 from "../assets/lotties/friendly/instrucFis2.json";
import instrucGeo from "../assets/lotties/friendly/instrucGeo.json";
import instrucIng from "../assets/lotties/friendly/instrucIng.json";
import instrucQuim from "../assets/lotties/friendly/instrucQuim.json";
import intrucMate from "../assets/lotties/friendly/intrucMate.json";
import intrucMate2 from "../assets/lotties/friendly/intrucMate2.json";
import libros from "../assets/lotties/friendly/libros.json";
import lottieAlumnBlack from "../assets/lotties/friendly/lottie_alumn_black.json";
import lottieAstronauta from "../assets/lotties/friendly/lottie_astronauta.json";
import lottieFrankito1 from "../assets/lotties/friendly/lottie_frankito1.json";
import lottiePizarra from "../assets/lotties/friendly/lottie_pizarra.json";
import lottieStar2 from "../assets/lotties/friendly/lottie_star2.json";
import lottieStars1 from "../assets/lotties/friendly/lottie_stars1.json";
import mobile from "../assets/lotties/friendly/mobile.json";
import planning from "../assets/lotties/friendly/planning.json";
import planning2 from "../assets/lotties/friendly/planning2.json";
import podium from "../assets/lotties/friendly/podium.json";
import podium2 from "../assets/lotties/friendly/podium2.json";
import podium3 from "../assets/lotties/friendly/podium3.json";
import podium4 from "../assets/lotties/friendly/podium4.json";
import prospecto2 from "../assets/lotties/friendly/prospecto2.json";
import ribbonFirst from "../assets/lotties/friendly/ribbonFirst.json";
import student1 from "../assets/lotties/friendly/student1.json";
import studentF from "../assets/lotties/friendly/studentF.json";
import studentPro from "../assets/lotties/friendly/studentpro.json";
import tareasCrono from "../assets/lotties/friendly/tareasCrono.json";
import task from "../assets/lotties/friendly/task.json";
import taskList from "../assets/lotties/friendly/taskList.json";
import teacher from "../assets/lotties/friendly/teacher.json";
import videos from "../assets/lotties/friendly/videos.json";
import warningAnim from "../assets/lotties/warning/warning.json";

// 👉 Array con todas las animaciones
const lotties = [
  alert, alumn1, bellAlert, bonus, book, bookFinal, books, books3, bookStar, bookPen,
  champ, chooseOption, claseDistancia, cuestionarios, cup, cup2, gift, gift2, gift3,
  goldChamp, good, goodCheck, goodCheckAplic, goodCheckBio, goodCheckEsp, goodCheckFilo,
  goodCheckFisAdmon, goodCheckGeo, goodCheckIng, goodCheckMatSoc, goodCheckQuimHist,
  horario, instrucBio, instrucFil, instrucFis, instrucFis2, instrucGeo, instrucIng,
  instrucQuim, intrucMate, intrucMate2, libros, lottieAlumnBlack, lottieAstronauta,
  lottieFrankito1, lottiePizarra, lottieStar2, lottieStars1, mobile, planning, planning2,
  podium, podium2, podium3, podium4, prospecto2, ribbonFirst, student1, studentF,
  studentPro, tareasCrono, task, taskList, teacher, videos
];

// 👉 Función que devuelve un Lottie aleatorio
export function getRandomLottie() {
  const randomIndex = Math.floor(Math.random() * lotties.length);
  return lotties[randomIndex];
}


// Array de lotties positivos
export const lottiesPositivosEval = [cup];

// Array de lotties negativos
export const lottiesNegativosEval = [warningAnim];